/* eslint-disable @typescript-eslint/no-explicit-any */
export let contxtSdk: any = undefined;

export function setGlobalContxtSdk(sdk: any): any {
  contxtSdk = sdk;
  return contxtSdk;
}
